import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=88449ca4"
import script from "./dispatch.vue?vue&type=script&lang=js"
export * from "./dispatch.vue?vue&type=script&lang=js"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=88449ca4&prod&lang=stylus&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports